export default __webpack_public_path__ + "static/media/timer_pause_inactive.ae85e8f0.svg";